import React from 'react'

export const FileManagerAsync = React.lazy(() => import('./file-manager'))
